import React, { useContext, useEffect, useState } from "react";
import { DatePicker, Row, Col } from "antd";
import { useDashboardModal } from "../../../components/dashboard-layout/modal/util";
import { useSelectableRow } from "../../dashboard/transporters/tableConfig";
import { DashboardSectionTitle } from "../../../components/dashboard-layout/styledComponents";
import DashboardTable from "../../../components/dashboard-layout/table/DashboardTable";
import TransporterForm from "../../dashboard/transporters/TransporterForm";
import { StatusItem } from "../../../components/dashboard-SA/InvoicesItem";
import { getInvoicesFromSuperAdmin } from "../../../Services/firebase";
import { Context } from "../../../Context";
import usePagination from "../../../hooks/usePagination";
import moment from "moment";
import { FaShoppingBag } from "react-icons/fa";
import DashboardItem from "../../../components/dashboard-SA/DashboardItem";
import { getInvoiceTotalPartner } from "../../../Services/firebase";

const { RangePicker } = DatePicker;

const columns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    render: (text) => <span>{text}</span>,
    sortDirections: ["descend"],
  },

  {
    title: "Fecha de creación",
    dataIndex: "date",
    key: "date",

    sortDirections: ["descend"],
  },
  {
    title: "Aliado",
    dataIndex: "ally",
    key: "ally",

    sortDirections: ["descend"],
  },
  {
    title: "Rango de Facturación",
    dataIndex: "range",
    key: "range",

    sortDirections: ["descend"],
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: ({ current, text }) => (
      <StatusItem status={current}>{text}</StatusItem>
    ),
    sortDirections: ["descend"],
  },
  {
    title: "Monto",
    dataIndex: "amount",
    key: "amount",
    sortDirections: ["descend"],
  },
];

const getTagColor = (status) => {
  if (status === "PENDING_CONFIRM_PAY") {
    return "error";
  }

  if (status === "PENDING_PAY") {
    return "warning";
  }

  if (status === "PAID") {
    return "success";
  }
};
const getTagText = (status) => {
  if (status === "PENDING_CONFIRM_PAY") {
    return "Pendiente por verificar";
  }

  if (status === "PENDING_PAY") {
    return "Pendiente por pago";
  }

  if (status === "PAID") {
    return "Pagado";
  }
};

const AllyInvoices = ({ history }) => {
  const rowSelectable = useSelectableRow();
  const modal = useDashboardModal();
  const { currentUser } = useContext(Context);
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [amountTotalPartner, setAmountTotalPartner] = useState(null);
  const [loadingIndicators, setLoadingIndicators] = useState(false);
  const [dateRange, setDateRange] = useState([
    moment().subtract(30, "days").startOf("day").format(),
    moment().endOf("day").format(),
  ]);
  const getIndicatorsValues = async () => {
    setLoadingIndicators(true);
    try {
      const responsePartner = await getInvoiceTotalPartner(true);
      setAmountTotalPartner(responsePartner.data);
      setLoadingIndicators(false);
    } catch (e) {
      console.log(e);
      setLoadingIndicators(false);
    }
  };
  const {
    page,
    itemsPerPage,
    onChangePage,
    onChangeItemsPerPage,
    setPagination,
    pagination,
  } = usePagination();

  useEffect(() => {
    const onGetInvoices = async () => {
      try {
        setLoading(true);

        const { data } = await getInvoicesFromSuperAdmin(
          page,
          itemsPerPage,
          dateRange,
          undefined,
          "PARTNER"
        );
        const formatedRows = data?.data?.map((row) => ({
          id: row.id,
          ally: row?.destination?.name,
          date: moment(row.createdAt).format("DD/MM/YYYY"),
          range: `${moment(row.initDate.split(".")[0]).format(
            "MMMM DD, hh:mm a"
          )} - ${moment(row.endDate.split(".")[0]).format("MMMM DD, hh:mm a")}`,
          amount: `$ ${new Intl.NumberFormat("de-DE").format(row.value)}`,
          status: {
            current: getTagColor(row.status),
            text: getTagText(row.status),
          },
        }));
        setPagination(data?.pagination);
        setInvoices(formatedRows);
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    };
    if (currentUser) {
      onGetInvoices();
    }
  }, [currentUser, page, itemsPerPage, dateRange]);

  const onClickRow = (e, row) => {
    if (
      e.target.parentElement.className.includes("icons") ||
      e.target.tagName === "svg"
    ) {
      return;
    }
    history.push(`/invoice/${row.id}`);
  };

  useEffect(() => {
    getIndicatorsValues();
  }, []);

  return (
    <>
      <Row>
        <Col span={12}>
          <DashboardSectionTitle>Facturas a Aliados</DashboardSectionTitle>
        </Col>
        <Col span={12}>
          <Row justify="end">
            <RangePicker
              defaultValue={[moment().subtract(30, "days"), moment()]}
              ranges={{
                Hoy: [moment(), moment()],
                "Mes en curso": [
                  moment().startOf("month"),
                  moment().endOf("month"),
                ],
                Semana: [moment().startOf("week"), moment().endOf("week")],
                "Últimos 30 días": [moment().subtract(30, "days"), moment()],
              }}
              onChange={(dates) =>
                setDateRange([
                  moment(dates[0]).startOf("day").format(),
                  moment(dates[1]).endOf("day").format(),
                ])
              }
            />
          </Row>
          <Row justify="end">
            <DashboardItem
              title="Total pendiente facturado por Aliados"
              value={`$ ${new Intl.NumberFormat("de-DE").format(
                amountTotalPartner
              )}`}
              factor=""
              icon={<FaShoppingBag />}
              iconColor="#F84B05"
              iconBg="#F84B0512"
              factorStatus="up"
              loading={loadingIndicators}
              minheight="80px"
            />
          </Row>
        </Col>
      </Row>
      <DashboardTable
        columns={columns}
        pagination={pagination}
        rowSelectable={rowSelectable}
        tableTitle="Lista de Facturas"
        buttonActionText="+ Crear transportador"
        data={invoices}
        page={page}
        onChangeItemsPerPage={onChangeItemsPerPage}
        onChangePage={onChangePage}
        loading={loading}
        onClickRow={onClickRow}
      />
      <TransporterForm modalSetting={modal} />
    </>
  );
};

export default AllyInvoices;
